import Appointment from "../../../model/appointment/Appointment";
import AppointmentType from "../../../model/appointment/AppointmentType";
import JobAppointment from "../../../model/appointment/job/JobAppointment";
import JobAppointmentType from "../../../model/appointment/job/JobAppointmentType";

/**
 * Fetch lead appointments successful action.
 */
export const LEAD_APPOINTMENTS_FETCHED = "LEAD_APPOINTMENTS_FETCHED";
export type LEAD_APPOINTMENTS_FETCHED = { appointments: Appointment[], leadId: string }

/**
 * Create appointment successful action.
 */
export const APPOINTMENT_CREATED = "APPOINTMENT_CREATED";
export type APPOINTMENT_CREATED = { appointment: Appointment }

/**
 * Update appointment successful action.
 */
export const APPOINTMENT_UPDATED = "APPOINTMENT_UPDATED";
export type APPOINTMENT_UPDATED = { appointment: Appointment }

/**
 * Delete appointment successful action.
 */
export const APPOINTMENT_DELETED = "APPOINTMENT_DELETED";
export type APPOINTMENT_DELETED = { appointmentId: string, leadId: string }

/**
 * Fetch lead appointment types successful action.
 */
export const APPOINTMENT_TYPES_FETCHED = "APPOINTMENT_TYPES_FETCHED";
export type APPOINTMENT_TYPES_FETCHED = { appointmentTypes: AppointmentType[] }

/**
 * Fetch job appointments successful action.
 */
export const JOB_APPOINTMENTS_FETCHED = "JOB_APPOINTMENTS_FETCHED";
export type JOB_APPOINTMENTS_FETCHED = { jobAppointments: JobAppointment[] }

/**
 * Create job appointment successful action.
 */
export const JOB_APPOINTMENT_CREATED = "JOB_APPOINTMENT_CREATED";
export type JOB_APPOINTMENT_CREATED = { jobAppointment: JobAppointment }

/**
 * Update job appointment successful action.
 */
export const JOB_APPOINTMENT_UPDATED = "JOB_APPOINTMENT_UPDATED";
export type JOB_APPOINTMENT_UPDATED = { jobAppointment: JobAppointment }

/**
 * Delete job appointment successful action.
 */
export const JOB_APPOINTMENT_DELETED = "JOB_APPOINTMENT_DELETED";
export type JOB_APPOINTMENT_DELETED = { appointmentId: string }

/**
 * Fetch job appointment types successful action.
 */
export const JOB_APPOINTMENT_TYPES_FETCHED = "JOB_APPOINTMENT_TYPES_FETCHED";
export type JOB_APPOINTMENT_TYPES_FETCHED = { jobAppointmentTypes: JobAppointmentType[] }

/**
 * Fetch lead appointments successful action
 */
export const LEAD_APPOINTMENTS_IN_DATE_RANGE_FETCHED = "LEAD_APPOINTMENTS_IN_DATE_RANGE_FETCHED"
export type LEAD_APPOINTMENTS_IN_DATE_RANGE_FETCHED = { appointments: { [key: string]: Appointment[] } }

/**
 * Fetch job appointments successful action
 */
export const JOB_APPOINTMENTS_IN_DATE_RANGE_FETCHED = "JOB_APPOINTMENTS_IN_DATE_RANGE_FETCHED"
export type JOB_APPOINTMENTS_IN_DATE_RANGE_FETCHED = { appointments: JobAppointment[] }
